import {
  Edit,
  SimpleForm,
  SelectInput,
  TextInput,
  DateInput,
  useRecordContext,
} from 'react-admin'
import Grid from '@mui/material/Grid'

import GridContainer from '../../components/GridContainer'

const REFUND_STATUSES = [
  { id: 'pending', name: 'Chờ xử lý' },
  { id: 'processed', name: 'Đã xử lý' },
]

const formatAmount = (amount, currency = 'VND') => {
  if (!amount) return '0'
  const roundedAmount = Math.round(amount)
  const formatter = new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: currency || 'VND',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
  return formatter.format(roundedAmount)
}

const AmountInput = () => {
  const record = useRecordContext()
  return (
    <TextInput
      label="Số tiền"
      source="amount"
      disabled
      fullWidth
      format={value => formatAmount(value, record?.currency)}
    />
  )
}

const RefundEdit = props => {
  return (
    <Edit {...props}>
      <SimpleForm>
        <GridContainer>
          <Grid item xs={12}>
            <TextInput source="id" disabled fullWidth />
          </Grid>
          <Grid item xs={12}>
            <TextInput label="User ID" source="userId" disabled fullWidth />
          </Grid>
          <Grid item xs={12}>
            <AmountInput />
          </Grid>
          <Grid item xs={12}>
            <DateInput
              label="Ngày refund"
              source="refundDate"
              disabled
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextInput
              label="Mã subscription"
              source="subscriptionId"
              disabled
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <SelectInput
              label="Trạng thái"
              source="status"
              choices={REFUND_STATUSES}
              fullWidth
              variant="standard"
            />
          </Grid>
          <Grid item xs={12}>
            <TextInput
              source="note"
              label="Ghi chú"
              resettable
              rows={1}
              fullWidth
              variant="standard"
              multiline
            />
          </Grid>
        </GridContainer>
      </SimpleForm>
    </Edit>
  )
}

export default RefundEdit
